import { render } from "./CustomPage.vue?vue&type=template&id=7f28f0c2&scoped=true"
import script from "./CustomPage.vue?vue&type=script&lang=js"
export * from "./CustomPage.vue?vue&type=script&lang=js"

import "./CustomPage.vue?vue&type=style&index=0&id=7f28f0c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f28f0c2"]])

export default __exports__